// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line no-unused-vars
import { Field } from 'react-final-form';
// eslint-disable-next-line no-unused-vars
import { Label } from '@americanexpress/dls-react';
import { contactUpdateFormFields } from './UpdateContactFormInitData';
import labels from '../../../constants/labels';

const UpdateContactChildForm = ({ dialCodes = [] }) => (
  <div className="flex margin-2-b">
    <Field {...contactUpdateFormFields.contactName} />
    <div className="col-md-3">
      <Label
        id={`${contactUpdateFormFields.phoneNo.id}-label`}
        htmlFor={contactUpdateFormFields.phoneNo.id}
      >
        {labels.CONTACT_PHNO}
        {contactUpdateFormFields.phoneNo.isRequired ? ' *' : ''}
      </Label>
      <div className="flex">
        <Field {...contactUpdateFormFields.countryId} options={dialCodes} />
        <Field {...contactUpdateFormFields.phoneNo} />
      </div>
    </div>
    <Field {...contactUpdateFormFields.emailAddress} disabled={true} />
    <Field {...contactUpdateFormFields.role} disabled={true} />
  </div>
  );

UpdateContactChildForm.displayName = 'UpdateContactChildForm';

UpdateContactChildForm.propTypes = {
  dialCodes: PropTypes.arrayOf(),
};

export default UpdateContactChildForm;
